<template>
    <div class="down-app"
         v-if="show">
        <!--        <div class="logo">-->
        <!--            <img src="@/assets/img/logo.png" alt="" class="logo-pic">-->
        <!--            <span class="name">知东莞</span>-->
        <!--        </div>-->
        <!--        <div class="down-btn" @click="open">下载APP</div>-->
        <van-swipe class="down-app"
                   :autoplay="3000"
                   indicator-color="#3a3a3a"
                   :loop="true"
        >
            <van-swipe-item v-if="detail.setting"
                            class="item">
                <div class="left">
                    <img :src="detail.setting.download_bar_logo"
                         alt=""
                         class="logo-pic" style="width: 44px;">
                    <div class="info">
                        <div>{{detail.setting.system_title}}</div>
                        <div class="remark">{{detail.setting.download_bar_desc}}</div>
                    </div>
                </div>
                <div class="right">
                    <button class="down-btn"
                            id="btn-0">{{detail.setting.download_bar_button}}</button>
                    <van-icon name="cross"
                              class="close-btn"
                              @click="show = false" />
                </div>
            </van-swipe-item>
            <van-swipe-item v-for="(item, index) in detail.data"
                            :key="item.id"
                            class="item">
                <div class="left">
                    <img :src="item.image"
                         alt=""
                         class="logo-pic">
                    <div class="info">
                        <div>{{item.title}}</div>
                        <div class="remark">{{item.desc}}</div>
                    </div>
                </div>
                <div class="right">
                    <button class="down-btn"
                            :id="`btn-${index + 1}`">{{detail.setting.download_bar_button}}</button>
                    <van-icon name="cross"
                              class="close-btn"
                              @click="show = false" />
                </div>
            </van-swipe-item>
        </van-swipe>
    </div>
</template>
<script>
import { downloadInfoApi } from "../request/api";
export default {
    data() {
        return {
            show: false,
            detail: {},
            linkID: "usr1kva5smt2abij",
        };
    },
    props: {
        linkData: {
            type: Object,
            default: () => {},
        },
    },
    created() {
        this.checkIsShare();
        this.addLinkDataListener();
    },
    methods: {
        open() {
            this.openDownModal();
        },
        setShareInfo(data) {
            console.log(data);
        },
        addLinkDataListener() {
            this.$bus.$on("linkDataUpdate", (data) => {
                this.initULink(data);
            });
        },
        initULink(data) {
            // 获取所有按钮
            let btns = document.getElementsByClassName("down-btn");
            let arr = [];
            for (var key in btns) {
                // 是元素
                if (btns[key].getAttribute) {
                    arr.push(`#${btns[key].getAttribute("id")}`);
                }
            }
            ULink({
                id: this.linkID,
                data: {
                    ...data,
                    // redirectPath: 1, //固定值
                    // url: window.location.href,
                    // title: "2022年3月29日东莞市新冠肺炎疫情情况",
                    // id: 277415,
                },
                selector: arr.join(","), //点击下载按钮的id
                timeout: 3000,
                useOpenInBrowerTips: "default",
                lazy: false,
                auto: false,
                useClipboard: false,
                onready: function (ctx) {},
            });
        },
        checkIsShare() {
            let paramsStr = window.location.href.split("?")[1];
            if (!paramsStr) return;
            let data = this.getParams(paramsStr);
            if (data.isShare == 1) {
                this.show = true;
                this.getData();
            }
        },
        getParams(str) {
            let obj = {};
            let arr = str.split("&");
            arr.forEach((item) => {
                obj[item.split("=")[0]] = item.split("=")[1];
            });
            return obj;
        },
        getData() {
            downloadInfoApi().then((res) => {
                this.detail = res;
                // this.$nextTick(() => {
                //     this.initULink();
                // });
            });
        },
    },
};
</script>

<style lang="less">
.down-app:extend(.flex-btw) {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    width: 100%;
    background-color: rgba(255,255,255, .8);
    box-sizing: border-box;
    .item {
        box-sizing: border-box;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        overflow: hidden;
        .left {
            display: flex;
            align-items: center;
            width: 230px;
            height: 44px !important;
            .logo-pic {
                width: 66px;
                height: 44px;
                margin-right: 5px;
                border-radius: 5px;
            }
            div {
                font-size: 18px;
                font-weight: bold;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .remark {
                font-size: 12px;
                font-weight: normal;
                color: #878787;
            }
        }
        .right{
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
.down-btn {
    padding: 7px 20px;
    font-size: 12px;
    color: #fff;
    border-radius: 100px;
    background: linear-gradient(135deg, #FF7B9A 0%, #FF1544 100%);
    white-space: nowrap;
    margin-left: 10px;
    border: none;
    margin-right: 10px;
}
.van-swipe__indicators{
    bottom: 3px !important;
}
.van-swipe__indicator{
    background-color: rgba(0,0,0,1);
    transform: scale(.8);
}
</style>
